/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "@/src/components/Form/Common/Style/summaryStyle";
import Typography from "@mui/material/Typography";
import SummaryDetailsItem from "@/src/components/Form/Common/SummaryDetailsItem/SummaryDetailsItem";
import { translate } from "@/src/services/translations/translations";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { Box } from "@mui/material";

type TerminationProps = {
  product: AbstractCase;
};
const Termination = ({ product }: TerminationProps) => {
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h6"}>Kündigung</Typography>
      </Grid>
      <SummaryDetailsItem caseData={product} fieldPath={"contractTerminated"} />
      <SummaryDetailsItem caseData={product} fieldType={"date"} fieldPath={"contractTerminationReceivedDate"} />
      <SummaryDetailsItem caseData={product} fieldPath={"terminationNoticeType"} />
      <SummaryDetailsItem caseData={product} fieldPath={"preferredOutcome"} />
      <>
        <Grid sx={summaryStyle.question} size={12}>
          <Box id={"terminationObstacles"} />
          {translate("settlement.terminationObstacles.label", product)}
        </Grid>
        <Grid size={12}>
          {product.terminationObstacles.length
            ? product.terminationObstacles.map((value: string) => translate(`settlement.terminationObstacles.options.${value}.label`, product)).join(", ")
            : "Kein besonderer Kündigungsschutz"}
        </Grid>
      </>
    </>
  );
};

export default Termination;
